import { hexToRgba } from '../lib/MediumColor/hexToRgba';
import { appStorage } from './storage';
var THEMES = [];
if (!IS_ULTRA) {
    THEMES = THEMES.concat([
        {
            name: 'default',
            bg: '#ffffff',
            cell: '#03a7f9',
            cellShadow: 'rgba(48,182,249,0.5)',
            // Счётчики
            counters: 'rgba(75,75,75,1)',
            // Сетка
            gridBg1: '#82d6f3',
            gridBg2: '#a8e4fd',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#03a7f9',
            // Звезды
            cellWithStar: '#f1be39',
            star: '#fff',
        },
        {
            name: 'old-school',
            bg: '#ffffff',
            cell: '#03a7f9',
            cellShadow: 'rgba(48,182,249,0.5)',
            // Счётчики
            counters: 'rgba(75,75,75,1)',
            // Сетка
            gridBg1: '#82d6f3',
            gridBg2: '#a8e4fd',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#03a7f9',
            // Звезды
            cellWithStar: '#f1be39',
            star: '#fff',
        },
        {
            name: 'night',
            bg: '#25272d',
            cell: '#de9534',
            cellShadow: 'rgba(222,149,52,0.25)',
            // Счётчики
            counters: '#de9534',
            // Сетка
            gridBg1: '#2b2e35',
            gridBg2: '#31343c',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#CCCC00',
            // Звезды
            cellWithStar: '#de9534',
            star: '#fff',
        },
        {
            name: 'instagram',
            bg: '#ffdee7',
            cell: '#b752cf',
            cellShadow: 'rgba(216,162,252,0.85)',
            // Счётчики
            counters: '#b752cf',
            // Сетка
            gridBg1: '#ff9cbe',
            gridBg2: '#ffbed7',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#b752cf',
            // Звезды
            cellWithStar: '#b752cf',
            star: '#fff',
        },
        {
            name: 'white',
            bg: '#e3f3ff',
            cell: '#03a7f9',
            cellShadow: 'rgba(48,182,249,0.5)',
            // Счётчики
            counters: 'rgba(75,75,75,1)',
            // Сетка
            gridBg1: '#82d6f3',
            gridBg2: '#a8e4fd',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#03a7f9',
            // Звезды
            cellWithStar: '#f1be39',
            star: '#fff',
        },
        {
            name: 'green-lantern',
            bg: '#25272d',
            text: '#ffffff',
            cell: '#006666',
            cellShadow: 'rgba(0,102,102,0.5)',
            // Счётчики
            counters: '#006666',
            // Сетка
            gridBg1: '#2b2e35',
            gridBg2: '#31343c',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#006666',
            // Звезды
            cellWithStar: '#006666',
            star: '#fff',
        },
    ]);
}
export var get = function () {
    if (IS_ULTRA) {
        return {
            name: 'old-school',
            bg: '#448ac8',
            cell: '#b88d60',
            cellShadow: hexToRgba('#b88d60', '0.5'),
            // Счётчики
            counters: '#b88d60',
            // Сетка
            gridBg1: '#82d6f3',
            gridBg2: '#a8e4fd',
            // Анимация
            scoreAnimation: '#de9534',
            comboAnimation: '#03a7f9',
            // Звезды
            cellWithStar: '#b88d60',
            star: '#fff',
        };
    }
    return THEMES[appStorage.get().colorThemeId];
};
export var set = function (colorThemeName) {
    appStorage.upd({
        colorThemeId: THEMES.findIndex(function (_a) {
            var name = _a.name;
            return name === colorThemeName;
        }),
    });
};
